export enum LinksEnum {
  MAIN = '/assets',
  VESTING = '/vesting',
  VIP_LEVELS = '/vip',
  DEPOSIT_WITHDRAW = '/deposit',
  // MY_ASSET = '/dashboard',
  PRIVATE_SWAP = '/swap',
  FARMING = '/farming',
  REWARDS = '/rewards',
  VOTING = '/voting',
  CONTACT = '/contact',
  PRIVACY = '/privacy',
  TERMS = '/terms',
  NOTFOUND = '*',
}
